import {
    faArrowsRotate, faBolt, faBullseye, faCalendarDays, faCoins, faFire, faFlag, faGaugeHigh, faGift, faRepeat,
    faRocket, faStar, faTrophy, faUsers, faWandMagicSparkles,
} from '@fortawesome/free-solid-svg-icons';

import { COLOR_TOKENS } from '@/components/form/ColorPicker.jsx';

export const FLYWHEEL_ICONS = [
    { value: 'repeat', label: 'Repeat', icon: faRepeat },
    { value: 'refresh', label: 'Refresh', icon: faArrowsRotate },
    { value: 'rocket', label: 'Rocket', icon: faRocket },
    { value: 'calendar', label: 'Calendar', icon: faCalendarDays },
    { value: 'trophy', label: 'Trophy', icon: faTrophy },
    { value: 'coins', label: 'Coins', icon: faCoins },
    { value: 'users', label: 'Players', icon: faUsers },
    { value: 'sparkles', label: 'Sparkles', icon: faWandMagicSparkles },
    { value: 'gauge', label: 'Gauge', icon: faGaugeHigh },
    { value: 'target', label: 'Target', icon: faBullseye },
    { value: 'gift', label: 'Gift', icon: faGift },
    { value: 'flame', label: 'Flame', icon: faFire },
    { value: 'bolt', label: 'Bolt', icon: faBolt },
    { value: 'star', label: 'Star', icon: faStar },
];

export const MARKER_ICONS = [{ value: 'flag', label: 'Flag', icon: faFlag }, ...FLYWHEEL_ICONS];

const ICON_ALIASES = { zap: 'bolt', workflow: 'refresh' };

export const DEFAULT_FLYWHEEL_ICON = 'refresh';
export const DEFAULT_FLYWHEEL_COLOR = '--visual-color-1';

export const flywheelIconKey = (key) => {
    const k = ICON_ALIASES[key] || key;
    return MARKER_ICONS.some((i) => i.value === k) ? k : DEFAULT_FLYWHEEL_ICON;
};

export const flywheelIcon = (key) => MARKER_ICONS.find((i) => i.value === flywheelIconKey(key)).icon;

const TOKEN_BY_HEX = {
    '#6366f1': '--visual-color-1',
    '#8b5cf6': '--visual-color-2',
    '#db2777': '--visual-color-3',
    '#ec4899': '--visual-color-3',
    '#e25309': '--visual-color-4',
    '#f97316': '--visual-color-4',
    '#0d9488': '--visual-color-5',
    '#14b8a6': '--visual-color-5',
    '#0891b2': '--visual-color-6',
    '#06b6d4': '--visual-color-6',
    '#3b82f6': '--visual-color-7',
    '#059669': '--visual-color-8',
    '#10b981': '--visual-color-8',
    '#5c930c': '--visual-color-9',
    '#84cc16': '--visual-color-9',
    '#c026d3': '--visual-color-10',
    '#d946ef': '--visual-color-10',
};

const HEX = /^#[0-9a-f]{6}$/i;

export const colorToken = (color) => {
    if (typeof color !== 'string' || !color) return null;
    if (color.startsWith('--')) return color;
    return TOKEN_BY_HEX[color.toLowerCase()] || null;
};

export const colorValue = (color, fallback = 'var(--primary)') => {
    if (typeof color !== 'string' || !color) return fallback;
    if (color.startsWith('--')) return `var(${color})`;
    return HEX.test(color) ? color : fallback;
};

export const cleanColor = (color) => {
    if (typeof color !== 'string' || !color.trim()) return null;
    const c = color.trim();
    return c.startsWith('--') || HEX.test(c) ? c : null;
};

export const flywheelColor = (color) => colorValue(color, `var(${DEFAULT_FLYWHEEL_COLOR})`);

export const stableColor = (seed) => {
    let h = 0;
    for (let i = 0; i < String(seed).length; i += 1) h = (h * 31 + String(seed).charCodeAt(i)) | 0;
    return COLOR_TOKENS[Math.abs(h) % COLOR_TOKENS.length];
};
